var render = function (_h,_vm) {var _c=_vm._c;return _c('v-error-ct',{attrs:{"error":_vm.props.error,"tooltip":_vm.props.tooltip}},[_c('label',{attrs:{"for":_vm.props.name}},[_c('span',[_vm._v(_vm._s(_vm.props.label))]),_vm._t("default",null,null,_vm.$attrs)],2),_c('template',{slot:"additional"})],2)}
var staticRenderFns = []

export { render, staticRenderFns }